import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import setClass from '../../common/set-class';
import Select from '../select';
import Button from '../button';
const Pagination = ({ setPage, setSizePerPage, page, sizePerPage, total, sizePerPageOptions, fixSizePerPage, }) => {
    const firstItemIndex = useMemo(() => (page - 1) * sizePerPage + 1, [
        page,
        sizePerPage,
    ]);
    const lastItemIndex = useMemo(() => Math.min(page * sizePerPage, total), [
        page,
        sizePerPage,
        total,
    ]);
    const isFirstPage = useMemo(() => page === 1, [page]);
    const isLastPage = useMemo(() => page >= Math.ceil(total / sizePerPage), [
        page,
        sizePerPage,
        total,
    ]);
    const handlePreciousPage = useCallback(() => !isFirstPage && setPage(page - 1), [isFirstPage, page]);
    const handleNextPage = useCallback(() => !isLastPage && setPage(page + 1), [
        isLastPage,
        page,
    ]);
    const perPageSelectValue = useMemo(() => ({
        label: sizePerPage.toString(),
        value: sizePerPage,
    }), [sizePerPage]);
    const perPageOptions = useMemo(() => sizePerPageOptions.map((value) => ({
        value,
        label: value.toString(),
    })), [sizePerPageOptions]);
    const handlePerPageChange = useCallback(({ value }) => setSizePerPage(value), []);
    return (React.createElement("div", { className: "b-pagination" },
        React.createElement("div", { className: "b-pagination__per-page-label" }, " Row per page "),
        fixSizePerPage && (React.createElement("div", { className: "b-pagination__per-page-value" },
            " ",
            sizePerPage,
            " ")),
        !fixSizePerPage && (React.createElement(Select, { value: perPageSelectValue, options: perPageOptions, onChange: handlePerPageChange, className: "b-pagination__per-page-select" })),
        React.createElement("div", { className: "b-pagination__current-page-indexes" },
            firstItemIndex,
            "-",
            lastItemIndex,
            " of ",
            total),
        React.createElement(Button, { icon: "angle-left", kind: "link", onClick: handlePreciousPage, className: setClass('b-pagination__previous-btn', isFirstPage && 'b-pagination__disabled-btn') }),
        React.createElement(Button, { icon: "angle-right", kind: "link", onClick: handleNextPage, className: setClass('b-pagination__next-btn', isLastPage && 'b-pagination__disabled-btn') })));
};
Pagination.propTypes = {
    setPage: PropTypes.func.isRequired,
    setSizePerPage: PropTypes.func,
    page: PropTypes.number.isRequired,
    sizePerPage: PropTypes.number.isRequired,
    total: PropTypes.number,
    sizePerPageOptions: PropTypes.arrayOf(PropTypes.number),
    fixSizePerPage: PropTypes.bool,
};
Pagination.defaultProps = {
    total: 0,
    sizePerPageOptions: [10, 25, 50, 100],
    fixSizePerPage: true,
    setSizePerPage: undefined,
};
export default Pagination;
